import React from 'react'

import { AcornsIcon } from '@acorns/icons'
import { useRemoteStrings } from '@acorns/web-utils'

import themevalues from 'theme'

import {
  ProjectionContainerDisclaimer,
  ProjectionContainerHeading,
  ProjectionDisclaimerLink,
  StatsColumnPercentage,
  StatsColumnTitle,
  StatsContainer,
  StatsContainerColumn,
  StatsContainerDivider,
  StatsPercentIcon,
  StatsPercentIconContainer,
  YearProjectionContainer,
} from './styled-components'

type Props = {
  lowProjection?: number
  highProjection?: number
  averageProjection?: number
  hasBorder?: boolean
}

const YearProjectionOverview = ({
  lowProjection,
  highProjection,
  averageProjection,
  hasBorder = true,
}: Props) => {
  const { getRemoteString } = useRemoteStrings()

  return (
    <YearProjectionContainer hasBorder={hasBorder}>
      <ProjectionContainerHeading>
        {getRemoteString({
          key: 'portfolio.year_projection_overview.title',
        })}
      </ProjectionContainerHeading>
      <StatsContainer>
        <StatsContainerColumn>
          <StatsColumnTitle>
            {getRemoteString({
              key: 'portfolio.year_projection_overview.low',
            })}
          </StatsColumnTitle>
          <StatsPercentIconContainer>
            <StatsPercentIcon
              icon={AcornsIcon.Icon.ArrowDown}
              width="10px"
              height="13px"
            />
            <StatsColumnPercentage>
              {(lowProjection ? lowProjection.toFixed(1) : '--') + '%'}
            </StatsColumnPercentage>
          </StatsPercentIconContainer>
        </StatsContainerColumn>
        <StatsContainerDivider />
        <StatsContainerColumn>
          <StatsColumnTitle>
            {getRemoteString({
              key: 'portfolio.year_projection_overview.high',
            })}
          </StatsColumnTitle>
          <StatsPercentIconContainer>
            <StatsPercentIcon
              icon={AcornsIcon.Icon.ArrowUp}
              width="10px"
              height="13px"
            />
            <StatsColumnPercentage>
              {(highProjection ? highProjection.toFixed(1) : '--') + '%'}
            </StatsColumnPercentage>
          </StatsPercentIconContainer>
        </StatsContainerColumn>
        <StatsContainerDivider />
        <StatsContainerColumn>
          <StatsColumnTitle color={themevalues.colors.purple} isBold={true}>
            {getRemoteString({
              key: 'portfolio.year_projection_overview.average',
            })}
          </StatsColumnTitle>
          <StatsPercentIconContainer>
            <StatsPercentIcon
              icon={AcornsIcon.Icon.ArrowUp}
              width="10px"
              height="13px"
            />
            <StatsColumnPercentage>
              {(averageProjection ? averageProjection.toFixed(1) : '--') + '%'}
            </StatsColumnPercentage>
          </StatsPercentIconContainer>
        </StatsContainerColumn>
      </StatsContainer>
      <ProjectionContainerDisclaimer>
        {getRemoteString({
          key: 'portfolio.year_projection_overview.disclaimer',
        })}{' '}
        <ProjectionDisclaimerLink href="https://www.acorns.com/disclosures/">
          Important Disclosures.
        </ProjectionDisclaimerLink>
      </ProjectionContainerDisclaimer>
    </YearProjectionContainer>
  )
}

export default YearProjectionOverview
